import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import LoginBanner from "../../components/loginBanner";
import MessagePanel from "../../components/messagePanel";
import getProductData from "../../helpers/getProductData";
import { authActions } from "../../store/actions/auth.actions";
import { IDRaksStore } from "../../store/store";
import { AccountActionsState, IParams } from "../../store/types/auth";
import { Produkt } from "../../store/types/organizacje";
import LoginPageStyle from "../../styles/LoginPageStyle";

interface LoginPageProps {
  error: string;
  accountActionsState: AccountActionsState;
  onLogin: Function;
  onLoginToProduct: Function;
  onLoginInvite: Function;
  onLoginInviteToProduct: Function;
  onClearError: Function;
  onClearAccountActionsState: Function;
}

export const LoginPage = (props: LoginPageProps) => {
  const {
    error,
    accountActionsState,
    onLogin,
    onLoginToProduct,
    onLoginInvite,
    onLoginInviteToProduct,
    onClearError,
    onClearAccountActionsState,
  } = props;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const { product, host, redirect, idorganizacji, idzaproszenia } =
    useParams() as IParams;
  const productData = getProductData(product);
  const zaproszenie = idorganizacji && idzaproszenia;
  const zaproszenieZProduktu = zaproszenie && host && redirect;
  const loginDoProduktu = product && host && redirect;

  const validate = () => {
    onClearError();
    setEmailError(!email ? "Pole wymagane" : "");
    setPasswordError(!password ? "Pole wymagane" : "");
    if (email && password) return true;
    return false;
  };

  const handleLogin = (e: React.FormEvent<HTMLElement>) => {
    e.preventDefault();
    if (!validate()) return;
    if (loginDoProduktu)
      onLoginToProduct(email, password, productData.type, host, redirect);
    else if (zaproszenieZProduktu)
      onLoginInviteToProduct(
        email,
        password,
        idorganizacji,
        idzaproszenia,
        host,
        redirect
      );
    else if (zaproszenie)
      onLoginInvite(email, password, idorganizacji, idzaproszenia);
    else onLogin(email, password);
  };

  useEffect(() => {
    return () => {
      onClearError();
      onClearAccountActionsState();
    };
    // eslint-disable-next-line
  }, []);

  const signupLink = () => {
    if (zaproszenie) {
      if (zaproszenieZProduktu)
        return `/signupinvite/${idorganizacji}/${idzaproszenia}/${host}/${redirect}`;
      return `/signupinvite/${idorganizacji}/${idzaproszenia}`;
    } else if (loginDoProduktu)
      return `/signupproxy/${product}/${host}/${redirect}`;
    return `/signup`;
  };

  return (
    <>
      <LoginPageStyle>
        <div className="loginContainer">
          <div className="loginContainer__error">
            {error && (
              <MessagePanel title="Błąd" mode="error" message={error} />
            )}
            {accountActionsState ===
              AccountActionsState.ConfirmEmailSuccess && (
              <MessagePanel
                title="Sukces"
                mode="success"
                message="Dziękujemy za potwierdzenie konta."
              />
            )}
          </div>
          <div className="loginContainer__main">
            <div className="loginContainer__main__window">
              <h4 className="loginContainer__main__window__header">
                Zaloguj się
              </h4>
              <form onSubmit={handleLogin}>
                <FormControl error={emailError !== ""}>
                  <TextField
                    tc-data="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    label="Adres e-mail"
                  />
                  {emailError && (
                    <FormHelperText id="email-error-text">
                      {emailError}
                    </FormHelperText>
                  )}
                </FormControl>
                <FormControl
                  error={passwordError !== ""}
                  className="loginPassword"
                >
                  <TextField
                    tc-data="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    label="Hasło"
                  />
                  {passwordError && (
                    <FormHelperText id="password-error-text">
                      {passwordError}
                    </FormHelperText>
                  )}
                </FormControl>
                <div className="loginContainer__main__window__buttons">
                  <div className="loginContainer__main__window__buttons__resetlink">
                    <Link to="/resetpassinit" className="subtitle2">
                      Nie pamiętasz hasła?
                    </Link>
                  </div>
                  <Button type="submit" variant="contained" color="secondary">
                    ZALOGUJ
                  </Button>
                </div>
              </form>
            </div>
            <div className="loginContainer__main__additionaloption medium subtitle2">
              Nie masz jeszcze konta?{" "}
              <Link to={signupLink()} className="link">
                Zarejestruj się.
              </Link>
            </div>
            <div className="loginContainer__main__privacy disabled caption">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://ftp.raks.pl/marketing/download/pdf/faktury.raks.pl/regulamin_serwisu.pdf"
                className="link"
              >
                &nbsp;Regulamin&nbsp;
              </a>
              oraz
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://ftp.raks.pl/marketing/download/pdf/faktury.raks.pl/polityka_prywatnosci.pdf "
                className="link"
              >
                &nbsp;polityki prywatności.&nbsp;
              </a>
            </div>
          </div>
          <div className="loginContainer__footer"></div>
        </div>
        <LoginBanner
          appName={productData.appName}
          appDesc={productData.appDesc}
        />
      </LoginPageStyle>
    </>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    error: store.auth.error,
    accountActionsState: store.auth.accountActionsState,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onLogin: (email: string, pass: string) =>
      dispatch(authActions.login(email, pass)),
    onLoginToProduct: (
      email: string,
      pass: string,
      product: Produkt,
      host: string,
      redirect: string
    ) =>
      dispatch(
        authActions.loginToProduct(email, pass, product, host, redirect)
      ),
    onLoginInvite: (
      email: string,
      password: string,
      idOrganizacji: string,
      idZaproszenia: string
    ) =>
      dispatch(
        authActions.loginInvite(email, password, idOrganizacji, idZaproszenia)
      ),
    onLoginInviteToProduct: (
      email: string,
      password: string,
      idOrganizacji: string,
      idZaproszenia: string,
      host: string,
      redirect: string
    ) =>
      dispatch(
        authActions.loginInviteToProduct(
          email,
          password,
          idOrganizacji,
          idZaproszenia,
          host,
          redirect
        )
      ),
    onClearError: () => {
      dispatch(authActions.clearError());
    },
    onClearAccountActionsState: () =>
      dispatch(authActions.clearAccountActionsState()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
